import { ApiEndPoint } from './apiEndPoint'

export const getSession = new ApiEndPoint('session')

export const getEnrichment = new ApiEndPoint('system/enrichment')